module.exports = __webpack_public_path__ + "img/ltkbrasil-2x.ba7a835.jpg";